
var $window;

jQuery(document).ready(function($){
    //alert("test");

    $window = $(window);

    setTimeout(function(){ bootstrap_equalizer(); }, 300);
});

jQuery(window).resize(function ($) {
    //alert("test");
    bootstrap_equalizer();
});



function bootstrap_equalizer() {
    //alert("test");
    var windowsize = $window.width();
    if (windowsize > 768)
    {
        //alert(windowsize);
        jQuery(".row-eq-height").each(function () {
            var maxHeight = 0;
            // resize smaller blocks, that are inside a big resizable block, that is already in watch
            var heights = jQuery(this).find(".watch-inner").map(function () {

                var testHeight = jQuery(this).height();
                return testHeight;
            }).get(),

            maxHeight = Math.max.apply(null, heights);

            jQuery(this).find(".watch-inner").each(function () {
                jQuery(this).height(maxHeight);
            })


            // resize blocks that can contain smaller resizable blocks
            maxHeight = 0;
            var heights = jQuery(this).find(".watch").map(function () {

                var testHeight = jQuery(this).height();
                return testHeight;
            }).get(),

            maxHeight = Math.max.apply(null, heights);
            //alert(maxHeight);

            jQuery(this).find(".watch").each(function () {
                jQuery(this).height(maxHeight);
            })

        });
    }
}